import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    width: '100%',
    maxWidth: 396,
    display: 'flex',
    flexDirection: 'column',
  },
  paymentInfo: {
    padding: theme.spacing(6.25, 6.25, 6),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    borderRight: `1px solid ${theme.palette.blueGrey.light}`
  },
  topBlock: {
    position: 'relative'
  },
  backNav: {
    position: 'absolute',
    top: 0,
    left: 0,
    textDecoration: 'none !important',
    cursor: 'pointer'
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(1.75)
  },
  logoImg: {
    objectFit: 'contain',
    maxHeight: theme.spacing(4),
    maxWidth: theme.spacing(20),
  },
  icon: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    marginRight: theme.spacing(.25),
    '&:before': {
      display: 'inline-block',
      position: 'relative',
      content: '""',
      right: 0,
      width: theme.spacing(1),
      height: theme.spacing(1),
      transform: 'rotate(135deg)',
      borderRight: `1px solid ${theme.palette.blueGrey.light}`,
      borderBottom: `1px solid ${theme.palette.blueGrey.light}`,
      transition: 'all 200ms ease-in'
    }
  },
  link: {
    transition: 'all 200ms ease-in',
    color: theme.palette.blueGrey.light,
  },
  date: {
    textAlign: 'center'
  },
  bottomBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  logoBottom: {
    marginLeft: theme.spacing(.5),
    height: theme.spacing(2),
  },
  policyLink: {
    color: theme.palette.grey.main,
    fontSize: theme.spacing(1.25),
    lineHeight: 1,
  },
  logoLink: {
    display: 'flex',
    alignItems: 'start'
  },
  paymentCheckout: {
    padding: theme.spacing(6.25, 2, 6),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    height: '100%',
    alignItems: 'center'
  }
}))

export default useStyles
